/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ArrowRightIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' {...props}>
			<g fill='none' stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5}>
				<path data-name='Line 91' d='M.75 8.209h14.785' />
				<path data-name='Path 35826' d='m10.773 1.046 5.235 7.331-5.235 7.331' />
			</g>
		</svg>
	)
}

export default ArrowRightIcon
